import { put } from 'core_main/request';
import { UpdateSatisfactionResponseOptions } from './types';
import {
  validateUpdateSatisfactionResponseParams,
  makeSatisfactionResponseEndpoint,
} from './helpers';

export const updateSatisfactionResponse = (
  satisfactionResponseId: string,
  options: UpdateSatisfactionResponseOptions,
  lang?: string,
) => {
  const validateUpdateSatisfactionResponseError = validateUpdateSatisfactionResponseParams(
    satisfactionResponseId,
    options,
  );

  if (validateUpdateSatisfactionResponseError) {
    return Promise.reject(validateUpdateSatisfactionResponseError);
  }

  return put(makeSatisfactionResponseEndpoint(satisfactionResponseId, lang), {
    body: JSON.stringify(options),
  });
};
